import {
  loopbackDelete,
  LoopbackFilter,
  loopbackGet,
  loopbackPost,
  loopbackPut,
} from '..';
import { PartialBy } from '../../redux/types';
import { AuswertungSetting } from '../../redux/types/auswertungSettingTypes';

import { constructQueryParams } from './apiUtil';

export const getAuswertungSetting = async (
  trialId: number,
): Promise<AuswertungSetting|undefined> => {
  const filter: LoopbackFilter = {
    where: {
      trialId,
    },
  };
  const qp = constructQueryParams(filter);
  const setting = await loopbackGet(`AuswertungSettings${qp}`);
  if (setting.length) {
    return setting[0];
  }
  return undefined;
};

export const updateAuswertungSetting = (payload: PartialBy<AuswertungSetting, 'id'>): Promise<AuswertungSetting> => loopbackPut('AuswertungSettings', payload);
